<template>
  <div>
    <!-- <div class="adabundle-subheader"><h4>Readable Experience</h4></div> -->

    <div id="adabundle-readable-experience-box">
         <!--- adabundle-action-box adabundle-spinner-box -->

        <div v-for="experience_control in readable_experience_controls" v-show="experience_control.status == 1" :id="experience_control.id" class="adabundle-action-box adabundle-toggle-box">
            <div class="adabundle-action-box-content">
                <span class="adabundle-title">{{experience_control.title}}</span>
            </div>
            <div class="adabundle-input-spinner-box" data-step="5">
                <div class="adabundle-control">
                    <button class="adabundle-plus" role="button" tabindex="0" aria-label="Increase"></button>
                    <div class="adabundle-value" data-value="0">Default</div>
                    <button class="adabundle-minus" role="button" tabindex="0" aria-label="Decrease"></button>
                </div>
            </div>
        </div>


        <div v-for="experience_button in readable_experience_buttons" v-show="experience_button.status == 1" :id="experience_button.id" class="adabundle-action-box adabundle-toggle-box" tabindex="0">
            <div class="adabundle-action-box-content">
                <span class="adabundle-icon"></span>
                <span class="adabundle-title">{{experience_button.title}}</span>
            </div>
        </div>
      
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Utility from '../common/Utility';
import  HTTP from "../common/Http";

export default {
  name: "ReadableExperience",
  components: {
  },
  created () {
    this.init()
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'setWidgetOptions') {
        this.widgetOptions = state.widgetOptions;
        // this.init()
      }

      if (mutation.type === 'setWidgetLanguage') {
        this.init();
      }
    });
  },
  mounted(){
    this.logClicks();
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  data () {
    return {
      isLoading: false,
      readable_experience_controls:[],
      readable_experience_buttons:[] 
    }
  },
  computed: {
    ...mapState([
      "timeStamp",
      "wid",
      "widgetOptions",
      "t",
    ])
  },
  methods: {
    logClicks(){
      for(const button of this.readable_experience_controls){
        document.getElementById(button.id).addEventListener("click", (event) => {
            
            this.$store.dispatch('logClicks', { wid:this.wid, label: button.title, debug: this.debug});

            event.preventDefault();
        });
      }
      for(const buttonx of this.readable_experience_buttons){
        document.getElementById(buttonx.id).addEventListener("click", (event) => {
            
            this.$store.dispatch('logClicks', { wid:this.wid, label: buttonx.title, debug: this.debug});

            event.preventDefault();
        });
      }
    },
    init(){
        // this.readable_experience_controls = [
        //     {
        //         id: 'adabundle-action-content-scaling',
        //         title: 'Content Scaling',
        //         status: this.widgetOptions.contentScaling
        //     },
        //     {
        //         id: 'adabundle-action-font-sizing',
        //         title: 'Font Sizing',
        //         status: this.widgetOptions.fontSizing
        //     },
        //     {
        //         id: 'adabundle-action-line-height',
        //         title: 'Line Height',
        //         status: this.widgetOptions.lineHeight
        //     },
        //     {
        //         id: 'adabundle-action-letter-spacing',
        //         title: 'Letter Spacing',
        //         status: this.widgetOptions.letterSpacing
        //     }
        // ];

        const t = this.t;

        this.readable_experience_controls = [
            {
                id: 'adabundle-action-content-scaling',
                title: t.content_scaling.text,
                status: this.widgetOptions.contentScaling
            },
            {
                id: 'adabundle-action-font-sizing',
                title: t.font_sizing.text,
                status: this.widgetOptions.fontSizing
            },
            {
                id: 'adabundle-action-line-height',
                title: t.line_height.text,
                status: this.widgetOptions.lineHeight
            },
            {
                id: 'adabundle-action-letter-spacing',
                title: t.letter_spacing.text,
                status: this.widgetOptions.letterSpacing
            }
        ];

        // this.readable_experience_buttons = [
        //     {
        //         id: 'adabundle-action-text-magnifier',
        //         title: 'Text Magnifier',
        //         status: this.widgetOptions.textMagnifier
        //     },
        //     {
        //         id: 'adabundle-action-readable-font',
        //         title: 'Readable Font',
        //         status: this.widgetOptions.readableFont
        //     },
        //     {
        //         id: 'adabundle-action-dyslexia-font',
        //         title: 'Dyslexia Friendly',
        //         status: this.widgetOptions.dyslexiaFont
        //     },
        //     {
        //         id: 'adabundle-action-highlight-titles',
        //         title: 'Highlight Titles',
        //         status: this.widgetOptions.highlightTitles
        //     },
        //     {
        //         id: 'adabundle-action-highlight-links',
        //         title: 'Highlight Links',
        //         status: this.widgetOptions.highlightLinks
        //     },
        //     {
        //         id: 'adabundle-action-align-left',
        //         title: 'Left Aligned',
        //         status: this.widgetOptions.alignLeft
        //     },
        //     {
        //         id: 'adabundle-action-align-center',
        //         title: 'Center Aligned',
        //         status: this.widgetOptions.alignCenter
        //     },
        //     {
        //         id: 'adabundle-action-align-right',
        //         title: 'Right Aligned',
        //         status: this.widgetOptions.alignRight
        //     }
        // ] 

        this.readable_experience_buttons = [
            {
                id: 'adabundle-action-text-magnifier',
                title: t.text_magnifier.text,
                status: this.widgetOptions.textMagnifier
            },
            {
                id: 'adabundle-action-readable-font',
                title: t.readable_font.text,
                status: this.widgetOptions.readableFont
            },
            {
                id: 'adabundle-action-dyslexia-font',
                title: t.dyslexia_friendly.text,
                status: this.widgetOptions.dyslexiaFont
            },
            {
                id: 'adabundle-action-highlight-titles',
                title: t.highlight_titles.text,
                status: this.widgetOptions.highlightTitles
            },
            {
                id: 'adabundle-action-highlight-links',
                title: t.highlight_links.text,
                status: this.widgetOptions.highlightLinks
            },
            {
                id: 'adabundle-action-align-left',
                title: t.left_aligned.text,
                status: this.widgetOptions.alignLeft
            },
            {
                id: 'adabundle-action-align-center',
                title: t.center_aligned.text,
                status: this.widgetOptions.alignCenter
            },
            {
                id: 'adabundle-action-align-right',
                title: t.right_aligned.text,
                status: this.widgetOptions.alignRight
            }
        ] 
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
